<template>
  <div>
    <v-alert v-if="msg" :type="msgType">{{ msg }}</v-alert>
    <ListPage ref="appTable" :endpoint="apiCall" :headers="headers" title="Inventory" :showActionsColumn="false"
      :showViewButton="isAllowed('viewInventory')" @add="navigateTo('/app/inventory/0')" :showExportButton="isAllowed('deleteProduct')"
      @view="navigateTo(`/app/inventory/view/${$event._id}`)">
      <!-- Mobile View -->
      <template v-slot:item="{ item }" v-if="isMobile">
        <inventory-card :productInventory="item" :icons="icons"></inventory-card>
        <v-divider></v-divider>
      </template>

      <!-- Stock Display and Action Buttons for Web/Tablet View -->
      <template v-slot:stock="{ item }" v-if="isTabletAndUp">
        <v-chip small label :color="item.stock <= item.reserveStock ? 'red' : 'green'">{{ item.stock }}</v-chip>
      </template>
    </ListPage>
  </div>
</template>

<script>
import ActionButton from '@/components/ActionButton';
import appConstants from '@/utils/appConstants';
import InventoryCard from '@/components/InventoryResponsiveCard';
import ListPage from '@/components/common/ListPage.vue';

export default {
  components: {
    ActionButton,
    InventoryCard,
    ListPage,
  },
  data() {
    return {
      search: '',
      headers: [
        { text: 'Code', value: 'code', exportable:true },
        { text: 'Title', value: 'title', exportable:true },
        { text: 'Price', value: 'price', align: 'right', exportable:true },
        { text: 'Offer Price', value: 'offerprice', align: 'right', exportable:true },
        { text: 'Stock', value: 'stock', align: 'right', exportable:true },
        { text: 'Reserve Stock', value: 'reserveStock', align: 'right', exportable:true },
      ],
      items: [],

      loading: false,
      apiCall:  `${appConstants.PRODUCTS_API}?variant=allVariants`,
    };
  },
  methods: {
    navigateTo(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style scoped>
/* Additional styles if needed */
</style>